import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import totalClientIcon from '../../assets/total_client.svg'
import activeClientIcon from '../../assets/active_client.svg'
import totalBalIcon1 from '../../assets/total_balance_i1.svg'
import totalBalIcon2 from '../../assets/total_balance_i2.svg'
import PendingUserIcon from '../../assets/total_pending_user.svg'
import totalProfitIcon from '../../assets/total_profit.svg'
import botChargeIcon from '../../assets/total_botcharge.svg'
import totalDepositIcon from '../../assets/total_deposite_balance.svg'
import brokerIcon from '../../assets/total_broker.svg'
import axios from 'axios'

const PRODUCT_CONFIG = {
    "PG Silver": {
        backgroundColor: "#FA7565",
        icons: [
            { src: totalDepositIcon, width: "51px", position: { top: 11, left: 11 } },
            { src: totalClientIcon, width: "51px", position: { bottom: 11, right: 11 } }
        ]
    },
    "PG Gold": {
        backgroundColor: "#C89AFF",
        icons: [
            { src: botChargeIcon, width: "50px", position: { top: 15, left: 15 } },
            { src: totalClientIcon, width: "30px", position: { bottom: 11, right: 15 } }
        ]
    },
    "PG Platinum": {
        backgroundColor: "#00C39A",
        icons: [
            { src: totalDepositIcon, width: "51px", position: { top: 11, left: 11 } },
            { src: brokerIcon, width: "57px", position: { bottom: 4, right: 10 } }
        ]
    },
    "Combo": {
        backgroundColor: "#79DB70",
        icons: [
            { src: totalBalIcon2, width: "100px", position: { top: 20, left: 11 } },
            { src: totalBalIcon1, width: "57px", position: { bottom: 10, right: 10 } }
        ]
    }
};

function Dashboard() {
    const [dashboard, setDashboard] = useState();

    useEffect(() => {
        fetchDashboardData()
    }, [])

    const fetchDashboardData = (val) => {
        axios.get(`${process.env.REACT_APP_ADMIN_API_URL}admin/admin-dashboard`, {
            headers: {
                'x-product-type': 'PIP_GRID'
            }
        })
            .then(res => {
                setDashboard(res.data);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const renderProductBlocks = () => {
        if (!dashboard?.productSales) return null;

        return dashboard.productSales.map((product, index) => {
            const config = PRODUCT_CONFIG[product.productName] || {};
            const formattedAmount = product.productSelling?.toLocaleString("hi-IN") || "0";
            const saleCount = product.saleCount || 0;

            return (
                <Col key={product.productName} span={12}>
                    <div className='dashboard-block'
                        style={{
                            backgroundColor: config.backgroundColor || "#00C39A",
                            padding: "60px 20px",
                            textAlign: "center",
                            height: "100%",
                            position: "relative"
                        }}>
                        <h3 style={{ margin: "0 0 10px 0" }}>${formattedAmount}</h3>
                        <span style={{ display: "block" }}>{product.productName} ({saleCount || 0})</span>

                        {config.icons?.map((icon, i) => (
                            <img
                                key={i}
                                src={icon.src}
                                alt={`${product.productName} icon ${i + 1}`}
                                style={{
                                    width: icon.width,
                                    position: "absolute",
                                    ...icon.position
                                }}
                            />
                        ))}
                    </div>
                </Col>
            );
        });
    };

    return (
        <Row gutter={[20, 20]}>
            <Col span={24}>
                <Row gutter={[20, 20]}>
                    <Col span={6}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#00C39A", padding: "50px 10px 24px 10px", textAlign: "center" }}>
                                    <h3>{dashboard?.totalLeads?.toLocaleString("hi-IN") || 0}</h3>
                                    <span style={{ marginBottom: 34 }}>Total Leads</span>
                                    <img src={PendingUserIcon} style={{ width: "244px", margin: "auto" }} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={9}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FFD155", padding: "86px 10px 86px 50px" }}>
                                    <h3>{(dashboard?.totalUsers)?.toLocaleString("hi-IN") || 0}</h3>
                                    <span>Total users</span>
                                    <img src={totalBalIcon1} style={{ width: "70px", top: 24, left: 24 }} className='position' />
                                    <img src={totalBalIcon2} style={{ width: "147px", bottom: 18, right: 25 }} className='position' />
                                </div>
                            </Col>
                            <Col span={10}>
                                <div className='dashboard-block' style={{ backgroundColor: "#f9a19e", padding: "45px 10px 45px 25px" }}>
                                    <h3>{dashboard?.inactiveUsers || 0}</h3>
                                    <span>Inactive Users</span>
                                    <img src={totalClientIcon} style={{ width: "40px", top: 13, right: 12 }} className='position' />
                                </div>
                            </Col>
                            <Col span={14}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FF904B", padding: "45px 10px 45px 50px" }}>
                                    <h3>{dashboard?.activeUsers || 0}</h3>
                                    <span>Active Users</span>
                                    <img src={activeClientIcon} style={{ width: "50px", top: 13, right: 29 }} className='position' />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={9}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FCC699", padding: "40px 10px 20px 10px", textAlign: "center" }}>
                                    <h3>${dashboard?.totalDepositAmount?.toLocaleString("hi-IN") || 0}</h3>
                                    <span style={{ marginBottom: 34 }}>Total Deposite amount</span>
                                    <img src={totalProfitIcon} style={{ width: "283px", margin: "auto" }} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[20, 20]}>
                            {renderProductBlocks()}
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default Dashboard